import { Button, Container } from '@dansk-metal/ui';

import { CompanyMemberDto } from '@web/services/crm-api/rest';

import { getMembershipStatus } from '@web/utils/get-membership-type-from-flags';
import { removeFirstNumbersString } from '@web/utils/remove-first-string-number';

import styles from './members-list-item.module.scss';

interface MembersListItemProps {
	member: CompanyMemberDto;
	onClickHandler: () => void;
}

export function MembersListItem({ member, onClickHandler }: MembersListItemProps) {
	const membershipType = getMembershipStatus(member.flags ? member.flags : {}) || '-';

	return (
		<Container>
			<Button
				onClick={onClickHandler}
				className={styles.content}
				tabIndex={0}
				unstyled
			>
				<div className={styles.name_profession_container}>
					<h4 className={styles.name}>{member.firstName} {member.lastName}</h4>
					<span className={styles.profession}>{removeFirstNumbersString(member.positionName)}</span>
				</div>
				<div className={styles.tag}>
					<span>{membershipType}</span>
				</div>
			</Button>
		</Container>
	);
}
